// extracted by mini-css-extract-plugin
export default {"nextBtn":"TutorialNavigation_nextBtn__5cX4U","prevBtn":"TutorialNavigation_prevBtn__lkGTK","tourBtn":"TutorialNavigation_tourBtn__tgSce"};